import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { AssetVehicleApprovalService } from '../asset-vehicle-approval.service';

@Component({
  selector: 'app-dialog-asset-vehicle-approval',
  templateUrl: './dialog-asset-vehicle-approval.component.html',
  styleUrls: ['./dialog-asset-vehicle-approval.component.scss']
})
export class DialogAssetVehicleApprovalComponent implements OnInit {
  assetForm!: FormGroup;
  ApprovalDetails: any;
  RejectedDetails: any;
  entityDetails: any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<DialogAssetVehicleApprovalComponent>, private fb: FormBuilder, private assetvehicle: AssetVehicleApprovalService, private spinner: NgxSpinnerService,) { }
ngOnInit(): void {
  this.assetForm = this.fb.group({
    buildingName: ['', Validators.required],
    vehicleNumber: ['', Validators.required],
    majorCategory: ['', Validators.required],
    minorCategory: ['', Validators.required],
    organization: ['', Validators.required],
  });
  console.log('PENGIND DATA', this.data);
  this.entityDetails = this.data.entityQRId;
  this.onPatchValue();
}
onPatchValue() {
  this.assetForm.patchValue({
    buildingName: this.data.buildingName,
    vehicleNumber: this.data.vehicleNumber,
    majorCategory: this.data.majorCategoryName,
    minorCategory: this.data.minorCategoryName,
    organization: this.data.orgName
  });
}
onNoClick(){
  this.dialogRef.close();
}

Approve() {
  const payloadApproval = {
    "entityQrId": this.entityDetails,
    "approveStatus": "APPROVED"
  }
  this.spinner.show();
  this.assetvehicle.postApproval(payloadApproval).subscribe(
    {
      next: (res: any) => {
        this.ApprovalDetails = res;
        console.log('ApprovalDetails', this.ApprovalDetails);
        this.spinner.hide();
        this.dialogRef.close('save');
      },
      error: (error: any) => {
        this.spinner.hide();
      }
    }
  )
}

reject() {
  const payloadrejected = {
    "entityQrId": this.entityDetails,
    "approveStatus": "REJECTED"
  }
  this.spinner.show();
  this.assetvehicle.postApproval(payloadrejected).subscribe(
    {
      next: (res: any) => {
        this.RejectedDetails = res;
        console.log('RejectedDetails', this.RejectedDetails);
        this.spinner.hide();
        this.dialogRef.close('save');
      },
      error: (error: any) => {
        this.spinner.hide();
      }
    }
  )
}
}
